import { lineBreaker } from "@/helpers/textformatting";

function normalizeText(value) {
  return String(value || "")
    .replace(/\r/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function estimateTextLines(value) {
  const text = normalizeText(value);
  if (!text) {
    return 0;
  }

  return lineBreaker(text)[1] || 1;
}

function estimateNodeLines(node) {
  if (!node) {
    return 0;
  }

  if (node.nodeType === Node.TEXT_NODE) {
    return estimateTextLines(node.nodeValue);
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return 0;
  }

  const tagName = String(node.tagName || "").toLowerCase();

  if (tagName === "br") {
    return 1;
  }

  const children = Array.from(node.childNodes || []);
  const childLines = children.reduce((total, child) => total + estimateNodeLines(child), 0);

  if (tagName === "p" || tagName === "div" || tagName === "li") {
    return Math.max(1, childLines) + 1;
  }

  return childLines;
}

export function estimateHtmlLines(html) {
  const source = normalizeText(html);
  if (!source) {
    return 0;
  }

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${source}</div>`, "text/html");
    return estimateNodeLines(doc.body.firstElementChild);
  } catch (error) {
    return estimateTextLines(source);
  }
}

export function estimateRowLines(values = []) {
  const lines = values.reduce((max, value) => Math.max(max, estimateTextLines(value)), 0);
  return Math.max(1, lines || 0);
}
